import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DSAuthService } from '../../auth.service';

@Component({
  selector: 'mp-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['../shared/auth-form.scss'],
})
export class ForgotUsernameComponent implements OnInit {
  form: UntypedFormGroup;
  config;

  isEmailSent: boolean;

  constructor(public authService: DSAuthService) {}

  ngOnInit(): void {
    this.config = this.authService.configuration.forgot_username;
    this.form = new UntypedFormGroup({});
  }

  submit() {
    this.authService.submistForgotUsername(this.form.value);
    this.isEmailSent = true;
  }
}
